import { render, staticRenderFns } from "./ListPublicEvents.vue?vue&type=template&id=7345a236&"
import script from "./ListPublicEvents.vue?vue&type=script&lang=ts&"
export * from "./ListPublicEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports